// Facts the Privacy Policy and Terms of Service depend on. Fill in every
// bracketed value before publishing: the legal pages show a warning banner
// while any placeholder remains. Have a lawyer review both documents too.
//
// When you change what the app collects or who processes it (new provider,
// analytics, a different hosting region...), update the documents and bump
// lastUpdated.

export const LEGAL = {
  /** Legal name of the company or person that runs TaskFlow. */
  operatorName: 'Sajal Subhash Mandrekar',
  /** Where privacy requests, deletion requests and legal notices go. */
  contactEmail: 'sajalmandrekar@gmail.com',
  postalAddress: 'Panjim, Goa, India',
  /** Required contact for Indian users (IT Rules 2021 / DPDP Act 2023). */
  grievanceOfficer: 'Sajal Subhash Mandrekar',
  /** Courts for disputes (Terms, "Governing law"). */
  courtsCity: 'Panjim, Goa, India',
  /** Where the database and app servers run (Azure region). */
  hostingRegion: 'India (Microsoft Azure, Central India region)',
  /** Nobody younger may use the Service (COPPA, Google and Facebook account ages). */
  minimumAge: 13,
  /** Below this, a parent or guardian must consent (India's DPDP Act: under 18 is a child). */
  adultAge: 18,
  lastUpdated: 'October 2, 2026',
};

export const LEGAL_PLACEHOLDERS_REMAIN = Object.values(LEGAL).some(
  (v) => typeof v === 'string' && v.includes('[')
);
